<template>
  <div
    id="conference"
    ref="conf"
    :style="event.branding ? { background: event.branding.tertiaryColor } : { background: '#FFFFFF' }"
    class="conference-container"
  >
    <div v-if="isConference" class="remote-users">
      <div
        v-for="peer in hostPeers"
        :key="peer.id"
        class="remote-user"
        :class="[activeSpeaker.id === peer.id ? 'active' : '']"
        :style="{ width: calculateWidth() }"
      >
        <div class="remote-user-aspect-helper">
          <HostVideo
            v-if="
              Object.keys(peer.videoConsumer).length !== 0 &&
              (peer.role === 'host' || peer.role === 'hybrid') &&
              !peer.vidPaused
            "
            :peer="peer"
            :width="width"
            :current-user-count="currentUserCount"
            class="remote-user-inner"
          />
          <HostNoVideo
            v-else
            :peer="peer"
            :width="width"
            :current-user-count="currentUserCount"
            class="remote-user-inner"
          />
        </div>
      </div>
      <div v-for="number in testuser" :key="number" class="remote-user" :style="{ width: calculateWidth() }">
        <div class="remote-user-aspect-helper">
          <img class="remote-user-inner" src="https://picsum.photos/800/600" />
        </div>
      </div>
    </div>
    <div />
  </div>
</template>
<script>
/**
 * Component displaying the Conference
 * Handles the creation of the participants video tiles
 * @displayName Conference
 */

/* eslint-disable vue/no-unused-components*/
import Me from "./Me.vue";
import HostVideo from "./HostVideo.vue";
import HostNoVideo from "./HostNoVideo.vue";
import { mapState } from "vuex";

export default {
  name: "Conference",
  components: {
    Me,
    HostVideo,
    HostNoVideo,
  },
  props: {
    /**
     * Information about the curren event from Firebase
     * Background color, Language Combinations ...
     */
    event: Object,
    /**
     * Mediasoup Id of the current Presenter
     */
    currentPresentator: { type: Number, default: null },
  },
  data() {
    return {
      width: "360px",
      testuser: 0,
      confHeight: 0,
      confWidth: 0,
    };
  },
  computed: {
    ...mapState({
      isConference: (state) => state.mediasoup.isConference,
      peers: (state) => state.mediasoup.peers,
      activeSpeaker: (state) => state.mediasoup.activeSpeaker,
      mediasoupId: (state) => state.mediasoup.mediasoupId,
    }),
    /**
     * All users which will get a video tile
     */
    hostPeers() {
      let hostpeers = this.peers.filter(
        (peer) => (peer.role === "host" || peer.role === "hybrid") && peer.id !== this.mediasoupId,
      );
      console.log("hostpeers", hostpeers);
      return hostpeers;
    },
    currentUserCount() {
      return this.$store.getters["mediasoup/getHostsCount"] + this.testuser;
    },
  },
  beforeUnmount() {
    console.log("Conference before Unount");
  },
  deactivated() {
    console.log("conference deaktviated");
  },
  mounted: function () {
    console.log("object keys", this.hostPeers);
    this.getConfMeasurements();
  },
  methods: {
    /**
     * Used for Testing - creating a random RGB color String used as Background for Test Users in the style tag
     * @return {String} rgb(x,x,x)
     * @public
     */
    randomColor() {
      const r = () => Math.floor(256 * Math.random());

      return `rgb(${r()}, ${r()}, ${r()})`;
    },
    /**
     * Calculate width of the video tiles based on number of users in the conference
     * @public
     */
    calculateWidth() {
      const currentUserCount = this.$store.getters["mediasoup/getHostsCount"] + this.testuser;
      // get columns of vidoes
      const cols = Math.ceil(Math.sqrt(currentUserCount));
      // get rows of videos with the columns
      const rows = Math.ceil(currentUserCount / cols);
      // get the pixel witdh of a video
      const width = this.confWidth / cols;
      // get the pixel height of a video
      const height = (width / 16) * 9;

      console.log("height " + height);

      // get the width of each in video in percentage
      let widthInPercentage = 100 / cols;

      // check if videos would overlap conference container
      if (height * rows > this.confHeight) {
        let wishedWidth = (this.confHeight / rows / 9) * 16;
        widthInPercentage = 100 / (this.confWidth / wishedWidth);
      }

      // return correct value
      return `${widthInPercentage}%`;
    },
    /**
     * Get height and widht of the conference div
     * @public
     */
    getConfMeasurements() {
      if (this.$refs.conf) {
        this.$data.confHeight = this.$refs.conf.clientHeight;
        this.$data.confWidth = this.$refs.conf.clientWidth;
      } else {
        this.$data.confHeight = -1;
        this.$data.confWidth = -1;
      }
    },
  },
};
</script>
<style>
.remote-user {
  max-width: 100%;
  border: 2px solid transparent;
}
.remote-user-aspect-helper {
  width: 100%;
  padding-top: 56.25%;
  height: 0;
  position: relative;
  overflow: hidden;
}
.remote-user-inner {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  min-width: 100%;
  background: rgba(0, 0, 0, 0.2);
}
.remote-user-inner > video {
  min-height: 100%;
  width: auto;
  min-width: 100%;
  top: 50%;
  position: relative;
  transform: translateY(-50%);
}

/* Media query for screen size less than 680 */
@media screen and (max-width: 640px) {
  .remote-users {
    max-height: 100% !important;
    overflow: scroll !important;
    align-content: start !important;
  }
  .remote-user {
    width: 50% !important;
  }
}
</style>
